<template>
<div id="TeacherManage">

  <div
    v-if="TeacherManageShow"

    class="well"
    style="padding: 0 1em"
  >
    <div style="text-align: left; padding: 0.5rem 2rem">
    <button
        href="#"
        @click="AddTeacher()"
        class="btn btn-outline-success"
        type="button"
        style="font-size: 14px; text-align: right"
      >
        新增教師
      </button>
       目前教師共 {{total}}筆
    </div>

    <b-tabs content-class="mt-3" justified>
      <div
        class="dataTables_scrollBody"
        style="
          font-size: 14px;
          position: relative;
          overflow: auto;
          max-height: 100%;

          border-bottom: 1px solid #111;
          border-top: 1px solid #111;
        "
      >
        <b-table-simple
          class="ncut-table-menu-striped ncut-table-menu"
           fixed
          responsive
          bgcolor="#FFFFFF"
        >
          <b-thead class="ncut-thead-menu">
            <b-tr>
              <b-th style="min-width: 2em">教師編號</b-th>
              <b-th style="min-width: 5em">教師帳號</b-th>
              <b-th style="min-width: 5em">姓名</b-th>
               <b-th style="min-width: 5em">職稱</b-th>
                <b-th style="min-width: 10em">服務單位</b-th>
               <b-th style="min-width: 10em">連絡電話</b-th>
              <b-th style="min-width: 5em">Email</b-th>
              <b-th style="min-width: 20em">管理</b-th>
            </b-tr>
          </b-thead>
          <b-tbody class="ncut-tbody-menu">
            <b-tr
              v-for="(item, index) in filteredDocs"
              :key="item.tid"
              :index="item.tid"
              :name="item.tid"
              v-bind:style="{
                background: selectedRowIndex == index ? headerColor : '',
              }"
              @click="selectedRowIndex = index"
            >
              <b-td style="text-align: right">
                {{ item.tid}}
              </b-td>
              <b-td style="text-align: left">
                {{ item.idNo}}
              </b-td>
              <b-td style="text-align: left">{{ item.name }}</b-td>
              <b-td style="text-align: left">{{ item.jobTitle }}</b-td>
              <b-td style="text-align: left">
                {{ item.serviceUnit}}
              </b-td>
              <b-td  style="text-align: left">
                {{item.cellPhone}}
              </b-td>
              <b-td  style="text-align: left">
                {{item.email}}
              </b-td>

              <b-td>
                 <button
                  href="#"
                  @click="EditTeacher(item.tid)"
                  class="btn btn-outline-success"
                  type="button"
                  style="font-size: 14px"
                >
                  修改資料
                </button><br>

                <button
                  href="#"
                  @click.prevent="remove(item.tid)"
                  class="btn btn-outline-danger btn-sm"
                  type="button"
                  style="font-size: 14px"
                >
                  刪除
                </button><br>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
        <b-pagination
          v-model="currentPage"
          :total-rows="total"
          :per-page="pageSize"
          v-if="total > pageSize"
        />
      </div>
    </b-tabs>

    <b-modal ref="q-modal" hide-footer title="請注意">
      <div class="d-block text-center">
        <h3>是否確認刪除此筆資料(包含此教師所開課程和學員參加報名資訊)?</h3>
      </div>
      <b-button class="mt-3" variant="outline-danger" block @click="cancalRM"
        >取消刪除</b-button
      >
      <b-button class="mt-2" variant="outline-info" block @click="confirmRM"
        >刪除確認</b-button
      >
    </b-modal>

  </div>

  <b-modal size="xl"  ref="EditTeacher" hide-footer>
      <template #modal-title> 教師資料編輯 </template>
      <EditTeacher
        :TID="editId"
        @hideModal="hideModal('EditTeacher')"
      ></EditTeacher>
    </b-modal>

  <b-modal size="xl"  ref="AddTeacher" hide-footer>
      <template #modal-title> 新增教師資料 </template>
      <AddTeacher

        @hideModal="hideModal('AddTeacher')"
      ></AddTeacher>
    </b-modal>

  </div>
</template>

<script>
import EditTeacher from '@/components/EditTeacherView.vue'
import AddTeacher from '@/components/AddTeacherView.vue'
import * as tools from '../tool'
export default {
  name: 'TeacherManage',
  data () {
    return {
      Name: null,
      TeacherManageShow: false,
      cid: null,
      TID: null,
      signUpID: null,
      today: null,
      signUpStatus: null,
      selected: null,
      discountArray: ['正常價', '早鳥0.9折', '本校教職員工及親友（含退休）0.9折', '二人以上同行0.9折'],
      attributesClassID: 0,
      editId: 0,
      over: 0,
      total: 0,
      isIE: false,
      inputData: null,
      inputData2: null,
      selectedRowIndex: 0,
      currentPage: 1,
      currentPage2: 1,
      pageSize: 10,
      queryInfo: {
        sysId: 0
      }
    }
  },
  components: {
    EditTeacher,
    AddTeacher

  },
  methods: {
    EditTeacher (id) {
      var vm = this
      vm.editId = id
      vm.$refs.EditTeacher.show()
    },
    AddTeacher () {
      var vm = this
      vm.$refs.AddTeacher.show()
    },
    getAllTeacher () {
      const vm = this
      this.$http
        .get('./WebApi/ociaRep/GetociaTeacher/')
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData = response.data
            vm.total = vm.inputData.length
          }
        })
        .catch(function (error) {
          alert('網路連線失敗' + error)
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        })
    },

    remove (TID) {
      this.TID = TID
      this.$refs['q-modal'].show()
    },
    cancalRM () {
      this.$refs['q-modal'].hide()
    },
    hideModal (name) {
      this.$refs[name].hide()
      this.getAllTeacher()
    },
    confirmRM () { // 刪除教師資料
      this.$refs['q-modal'].hide()
      var vm = this
      this.$http
        .get('./WebApi/ociaRep/RemoveTeacher/'.concat(this.TID))
        .then((response) => {
          if (response.data) {
            tools.showAlert(vm, 'success', '恭喜您,刪除成功')
            vm.getAllTeacher()
          } else {
            tools.showAlert(vm, 'danger', '對不起,刪除失敗')
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '網路連線失敗' + error)
        })
    }

  },
  computed: {
    filteredDocs: function () {
      let data = []
      if (this.inputData != null) {
        data = this.inputData.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        )
      }
      return data
    },
    filteredDocs2: function () {
      let data = []
      if (this.inputData2 != null) {
        data = this.inputData2.slice(
          (this.currentPage2 - 1) * this.pageSize,
          this.currentPage2 * this.pageSize
        )
      }
      return data
    },
    headerColor () {
      return '#f7e8aa'
    }

  },
  created () {
    console.log('======created CourseManageView =====')
    this.isIE =
      navigator.userAgent.indexOf('MSIE ') > -1 ||
      navigator.userAgent.indexOf('Trident/') > -1 ||
      navigator.userAgent.indexOf('Edge') > -1
    const vm = this

    vm.TeacherManageShow = true
    vm.getAllTeacher()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
